import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from './api';
import { getNewStateByAttr, getNewStateById } from './entities';
import { fetchFantasyEventGames } from './fantasyEventGames';
export const EVENT_GAMES_CONFIG_BRACKET_POOLS = 'Bracket Pools';
export const EVENT_GAME_TYPE_BRACKET_POOLS = 'bracket_pools';
const initialState = {
    byDate: {},
    byId: {},
    byLeague: {},
    status: 'init'
};
export const fetchEventGames = createAsyncThunk('eventGames/fetch', async (options, thunkApi) => {
    try {
        return await (await api.instance).fetchEventGames(options);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export const fetchEventGamesByIds = (eventGamesIds, gameType) => {
    const options = { pkIn: eventGamesIds, gameType };
    return fetchEventGames(options);
};
export const fetchOpenEventGames = () => {
    return fetchEventGames();
};
export const fetchRecentEventGames = () => {
    const options = {
        finalize_event__gt: new Date().toISOString(),
        include_reserved: true
    };
    return fetchEventGames(options);
};
const applyEventGamesState = (state, eventGames) => {
    state.byId = getNewStateById(state.byId, eventGames);
    state.byDate = getNewStateByAttr(state.byId, 'closeEventTs');
    state.byLeague = getNewStateByAttr(state.byId, 'league');
};
const eventGamesSlice = createSlice({
    name: 'eventGames',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchEventGames.fulfilled, (state, action) => {
            applyEventGamesState(state, action.payload.eventgames);
            state.status = 'success';
        })
            .addCase(fetchFantasyEventGames.fulfilled, (state, action) => {
            action.payload.forEach((fantasyEventGame) => {
                applyEventGamesState(state, [fantasyEventGame.eventGames]);
            });
        })
            .addCase(fetchEventGames.pending, (state) => {
            state.status = 'fetching';
        })
            .addCase(fetchEventGames.rejected, (state) => {
            state.status = 'error';
        });
    }
});
export const eventGamesReducer = eventGamesSlice.reducer;
